const sessionStorageKeys = {
  // Add more as needed
};

const localStorageKeys = {
  darkThemePreference: "dark_theme_preference",
  // Add more as needed
};

export { sessionStorageKeys, localStorageKeys }